/**
 * Public fetch hook for unauthenticated API calls
 * Used for browsing market data without authentication
 */
export const usePublicFetch = () => {
  const publicFetch = async (url: string, options?: RequestInit) => {
    try {
      const response = await fetch(url, {
        ...options,
        headers: {
          'Content-Type': 'application/json',
          ...options?.headers,
        },
      });
      
      return response;
    } catch (error) {
      console.error('Public fetch error:', error);
      throw error;
    }
  };

  return { publicFetch };
};